module.exports = __webpack_public_path__ + "img/share_linkedin.f62b6fca.svg";